import { Box, List, ListItem, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { Link } from 'react-router-dom'
import Image from '../../../shared/Image'
import logo from '../../../assets/images/logos/conduiit(twoeyes).svg'
import CustomButton from '../../../shared/CustomButton'
const useStyles = makeStyles((theme) => ({
  bookDemo: {
    padding: '80px 0',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      padding: '60px 0',
    },
    '& .lazy-load-image-background': {
      width: '100% !important',
      margin: '0 auto',
      '& img': {
        maxWidth: 220,
        margin: '0 auto',
        [theme.breakpoints.down('xs')]: {
          maxWidth: 155,
          paddingBottom: 25,
        },
      },
    },
  },
  demoButton: {
    borderRadius: 5,
    maxWidth: 307,
    minWidth: 307,
    fontSize: 16,
    padding: '0',
    '& a': {
      color: '#ffffff',
      height: '100%',
      width: '100%',
      padding: '15px 20px',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
      minWidth: 200,
      padding: '0',
    },
  },
  footerList: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: 15,
    background: '#E9E9E9',
    '& .MuiListItem-root': {
      width: 'max-content',
      '& a': {
        color: theme.palette.common.black,
        fontSize: 18,
        fontWight: 500,
        '&:hover': {
          color: theme.palette.primary.main,
        },
      },
    },
    '& .MuiListItem-root + .MuiListItem-root': {
      '&:before': {
        position: 'absolute',
        content: "''",
        left: 0,
        width: 2,
        height: '40%',
        background: theme.palette.common.black,
      },
      [theme.breakpoints.down('xs')]: {
        '&:nth-child(3)': {
          '&:before': {
            display: 'none',
          },
        },
      },
      [theme.breakpoints.down('370')]: {
        '&:before': {
          display: 'none',
        },
      },
    },
  },
}))

const HomeFooter = () => {
  const classes = useStyles()

  return (
    <>
      <Box className={classes.bookDemo}>
        <Image src={logo} alt="Conduiit" />
        <div id="myEle2"></div>
        <CustomButton
          variant="contained"
          color="primary"
          size="large"
          className={classes.demoButton}
        >
          <a
            href="https://getgist.me/sh29229pn/schedule"
            target="_blank
          "
          >
            {' '}
            BOOK A DEMO{' '}
          </a>
        </CustomButton>
      </Box>
      <Box>
        <List component="nav" className={classes.footerList}>
          <ListItem>
            <Link to="">
              <Typography variant="body1">Conduiit, Inc.</Typography>
            </Link>
          </ListItem>
          <ListItem>
            <Link to="">
              <Typography variant="body1">info@conduiit.com</Typography>
            </Link>
          </ListItem>
          <ListItem>
            <Link to="">
              <Typography variant="body1">917-691-1634</Typography>
            </Link>
          </ListItem>
          <ListItem>
            <Link to="">
              <Typography variant="body1">New Jersey || NY</Typography>
            </Link>
          </ListItem>
          <ListItem>
            <Link to="/term-conditions">
              <Typography variant="body1">Term and Conditions</Typography>
            </Link>
          </ListItem>
          <ListItem>
            <Link to="/privacy-policy">
              <Typography variant="body1">Privacy Policy</Typography>
            </Link>
          </ListItem>
        </List>
      </Box>
    </>
  )
}

export default HomeFooter
